// Generated from SVG to Code Figma Plugin

export const CutTailoring1 = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6 3.42871V17.9997H22"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M9 6H16.2877C17.2344 6 18.002 6.76751 18.002 7.71429V15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path d="M5.99805 6H1.99805" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    <path d="M18 20.5714V18" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
  </svg>
);
